import { html, ref, when, repeat } from '@microsoft/fast-element';
import { LinkAdvisorsCompanyRow } from './company-rows';
import { infoIcon } from '../../../../../styles';
import { BuyerAdvisorUserList } from '../link-advisors';

export const CompanyRowsTemplate = html<LinkAdvisorsCompanyRow>`
  <td class="icon-cells">
    <zero-radio current-checked=${(x) => x.selected} @click=${(x) => x.radioClick()}></zero-radio>
  </td>
  <td>${(x) => x.data?.COMPANY_NAME}</td>

  <td
    class="icon-cells info"
    ${ref('iconImg')}
    @mouseenter=${(x) => (x.showTooltip = true)}
    @mouseleave=${(x) => (x.showTooltip = false)}
  >
    ${infoIcon()}
  </td>
  ${when(
    (x) => x.showTooltip,
    html<LinkAdvisorsCompanyRow>`
      <fast-anchored-region
        class="info-tooltip"
        :anchorElement=${(x) => x.iconImg}
        vertical-positioning-mode="dynamic"
        vertical-default-position="center"
        horizontal-positioning-mode="dynamic"
      >
        <div class="tooltip-title">Assigned Advisors</div>
        <div class="tooltip-body">
          ${repeat(
            (x) => x.data.USER_LIST,
            html<BuyerAdvisorUserList>`
              <div>
                <div class="tooltip-username">${(x) => x.USERNAME}</div>
                <div class="tooltip-company">${(x) => x.COMPANY_NAME}</div>
              </div>
            `
          )}
        </div>
      </fast-anchored-region>
    `
  )}
`;
